// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_j6-0";
export var animationContainer = "_j6-1";
export var itemPrice = "_j6-a";
export var itemizedContent = "_j6-9";
export var itemizedHeader = "_j6-7";
export var itemizedRow = "_j6-8";
export var itemizedSection = "_j6-6";
export var modalContent = "_j6-2";
export var orderName = "_j6-3";
export var refundOption = "_j6-4";
export var refundOptionsContainer = "_j6-5";
export var shippingLabel = "_j6-b";
export var totalRow = "_j6-c";